import React, { useEffect, useState } from 'react'
import Style from './Hero.css'
import Pattern from '../../assets/national-scholars-pattern.svg'
import Logo from '../../assets/ua-logo.svg'

const Hero = (props) => {
  const [type, setType] = useState('National Scholar')
  useEffect(() => {
    let url = window.location.toString()
    let awardType = url.split('/awards/')
    if (awardType.length > 1) {
      if (awardType[1] === 'azmerit' || awardType[1] === 'merit') {
        setType('National Merit Semifinalist')
      }
    }
  }, [])
  return (
    <section className="hero">
      <div className="container">
        <div className="honors-pattern">
          <img src={Pattern} alt="" />
        </div>
        <div className="hero-wrap">
          <strong className="font-color-arizona-blue">HOW FAR WILL YOU GO?</strong>
          <div className="hero-copy-wrap">
            <img src={Logo} alt="University of Arizona Logo" />
            <h1 className="font-color-arizona-blue psuedo-before-color-arizona-red">
              Congratulations on your selection as a {type}. We would be proud to have you join us
              at the University of Arizona.
            </h1>
            <span>
              To fuel your ambition and demonstrate our commitment to your future, we’re pleased to
              offer you an additional, exclusive award on top of your scholarship to the University
              of Arizona.
            </span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
